import * as React from 'react';
import { BadgeSVGProps } from '../../BadgeImage/BadgeImage.types';

export const Shield = ({
  finish,
  isMetal,
  shineAsset,
}: BadgeSVGProps) => {
  console.log(shineAsset);
  return (
  <svg 
    version="1.1" 
    id="Layer_1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlnsXlink="http://www.w3.org/1999/xlink" 
    x="0px" 
    y="0px"
    viewBox="0 0 352 376.3" 
    enableBackground="new 0 0 352 376.3" 
    xmlSpace="preserve"
  >
    <g>
      <g>
        <rect id="SVGID_1_" x="175" y="-14" width="181" height="400" style={{ fill: 'transparent' }} />
      </g>
      <clipPath id="SVGID_2_">
        <use 
          xlinkHref="#SVGID_1_"  
          overflow="visible"
        />
      </clipPath>
      <g clipPath="url(#SVGID_2_)">
        <radialGradient id="SVGID_3_" cx="174.9525" cy="188.4051" r="174.0317" gradientUnits="userSpaceOnUse">
          <stop  offset="0" style={{ stopColor: "#ffffff" }} />
          <stop  offset="0.5379" style={{ stopColor: "#072551" }} />
          <stop  offset="0.7317" style={{ stopColor: "#07224A" }} />
          <stop  offset="0.8694" style={{ stopColor: "#061D3F" }} />
          <stop  offset="0.9803" style={{ stopColor: "#05162E" }} />
          <stop  offset="1" style={{ stopColor: "#05142A" }} />
        </radialGradient>
        <path className="background-colour" fill="url(#SVGID_3_)" d="M60,39.9c0,0,71.8,13.5,112.5-31.8h4.1c0,0,31.2,43,116.8,30.6c0,0,28.6-7.2,35,2.5
          c0,0,11.6,1.5,14.2,57.3c0,0-1.2,75-21.7,110.3c0,0-18.2,48.5-65.9,101.7c0,0-43.1,44.8-80.4,58.1c0,0-42.8-18.8-77.8-55
          c0,0-56.7-63.3-72.3-114.5c0,0-16.2-26.6-17.1-107.3C8.5,80.8,9.9,69.6,12,58.6c1.1-5.7,1.8-10,2.9-12.1
          c6.1-8.7,16.9-12.8,27.5-11.8C42.4,34.7,48.4,37,60,39.9z"
        />
        <g>
          <linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="21.4461" y1="118.552" x2="282.3048" y2="118.552">
            <stop  offset="0" style={{ stopColor: isMetal ? 'black' : finish.dark }} />
            <stop  offset="0.2462" style={{ stopColor: isMetal ? 'black' : finish.light }} />
            <stop  offset="0.4444" style={{ stopColor: isMetal ? 'black' : "#FFFFFF" }} />
            <stop  offset="0.695" style={{ stopColor: isMetal ? 'black' : finish.dark }} />
            <stop  offset="1" style={{ stopColor: isMetal ? 'black' : finish.light }} />
          </linearGradient>
          <polyline fill="url(#SVGID_4_)" points="25.3,202.2 282.3,41.1 278.5,34.9 21.4,196       "/>
          <linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="66.6977" y1="202.2624" x2="349.7231" y2="202.2624">
            <stop  offset="0" style={{ stopColor: isMetal ? 'black' : finish.dark }} />
            <stop  offset="0.2462" style={{ stopColor: isMetal ? 'black' : finish.light }} />
            <stop  offset="0.5422" style={{ stopColor: isMetal ? 'black' : finish.dark }} />
            <stop  offset="0.7693" style={{ stopColor: isMetal ? 'black' : finish.light }} />
            <stop  offset="0.9492" style={{ stopColor: isMetal ? 'black' : "#FFFFFF" }} />
          </linearGradient>
          <polyline fill="url(#SVGID_5_)" points="70.5,292.7 349.7,118 345.9,111.9 66.7,286.5       "/>
        </g>
        <linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="-0.7684" y1="188.7122" x2="350.6717" y2="188.7122">
          <stop  offset="0" style={{ stopColor: finish.dark }} />
          <stop  offset="0.2462" style={{ stopColor: finish.light }} />
          <stop  offset="0.4444" style={{ stopColor: finish.dark }} />
          <stop  offset="0.695" style={{ stopColor: finish.dark }} />
          <stop  offset="1" style={{ stopColor: finish.light }} />
        </linearGradient>
        <path fill="url(#SVGID_6_)" d="M60,39.9l-1.5,8c0.4,0.1,10.8,2,26.2,2c12.9,0,29.2-1.4,46-6.6c8.4-2.6,16.8-6.2,25-11
          c8.1-4.9,15.9-11,22.9-18.8l-6.1-5.5v8.1h4.1V8.1l-6.6,4.8c0.5,0.7,7.2,9.7,22.2,18.7c15,8.9,38.3,17.6,71.3,17.6
          c9.5,0,19.9-0.7,31-2.3l0.4-0.1l0.4-0.1l0,0c0.2,0,2.6-0.6,6-1.2c3.4-0.6,7.9-1.1,11.8-1.1c2.7,0,5.2,0.3,6.8,0.7
          c0.8,0.2,1.3,0.5,1.5,0.6l0.2,0.1l0.4-0.4l-0.5,0.3l0.1,0.1l0.4-0.4l-0.5,0.3l3.2,2.7c0,0,0,0,0,0s0.6,0.6,1.4,2.2
          c1.2,2.3,3,6.8,4.5,14.5c1.6,7.7,2.9,18.7,3.7,33.9l8.1-0.4l-8.1-0.1l0,0.2c0,2-0.5,20.8-3.4,43c-1.4,11.1-3.5,23.1-6.3,34.2
          c-2.8,11.1-6.5,21.4-10.9,28.9l-0.3,0.6l-0.2,0.6l3.1,1.2l-3.1-1.2l0,0l3.1,1.2l-3.1-1.2c0,0.1-18,47.4-64.4,99.1l6.1,5.4
          l-5.9-5.6l0,0c-0.5,0.5-11.3,11.6-26.2,24c-7.5,6.2-16,12.7-24.8,18.5c-8.8,5.7-17.9,10.6-26.2,13.6l2.7,7.7l3.3-7.5l-1,2.4l1-2.4
          l0,0l-1,2.4l1-2.4c-0.1,0-10.5-4.7-25.1-13.6c-14.6-9-33.4-22.3-50.1-39.5l-5.9,5.7l6.1-5.4l0,0c-0.7-0.8-14.8-16.7-30.5-38.4
          C64.5,259,56.2,246.6,49.1,234c-7.2-12.6-13.2-25.5-16.8-37.2l-0.3-1l-0.5-0.9l-3.2,1.9l3.2-1.9l0-0.1l-3.2,1.9l3.2-1.9
          c0-0.1-3.8-6.6-7.7-22.7c-3.9-16.1-7.8-41.9-8.2-80.5l-8.1,0.1l8.1,0.8c1.1-11,2.5-21.9,4.5-32.6c0.5-2.9,1-5.4,1.4-7.2
          c0.2-0.9,0.4-1.6,0.5-2.1c0.1-0.2,0.1-0.4,0.2-0.5l0-0.1l-1.2-0.6l1.2,0.6l0-0.1l-1.2-0.6l1.2,0.6l-7.1-3.9l6.7,4.7
          c1.9-2.7,4.5-4.8,7.5-6.3c3-1.5,6.6-2.2,10.2-2.2c0.8,0,1.6,0,2.4,0.1l0.8-8.1l-2.9,7.6c0.3,0.1,6.7,2.6,18.6,5.5l0.2,0.1l0.2,0
          L60,39.9l2-7.9c-5.6-1.4-9.8-2.7-12.7-3.6c-1.4-0.4-2.4-0.8-3.1-1c-0.3-0.1-0.6-0.2-0.7-0.3l-0.2-0.1l0,0l-1,2.5l1-2.5l0,0l-1,2.5
          l1-2.5l-1-0.4l-1.1-0.1c-1.3-0.1-2.6-0.2-3.9-0.2c-5.9,0-11.8,1.3-17.2,3.8c-5.4,2.6-10.2,6.5-13.8,11.6L8,42.2l-0.2,0.4
          c-0.7,1.3-1.1,2.4-1.4,3.5c-0.5,1.7-0.9,3.3-1.2,5.2C4.7,53.1,4.4,55,4,57.1c-2.2,11.3-3.6,22.7-4.7,34l0,0.4l0,0.4
          c0.4,40.9,4.8,68.3,9.1,85.8c4.3,17.4,8.7,24.9,9.2,25.7l7-4.2l-7.8,2.4c4.2,13.7,10.9,27.7,18.6,41.2
          c11.6,20.2,25.4,39.2,36.3,53.3c10.9,14,19,23.1,19.1,23.2l0.1,0.1l0.1,0.1c18.2,18.8,38.1,32.8,53.6,42.3
          c15.5,9.5,26.5,14.3,26.7,14.4l3,1.3l3.1-1.1c10.2-3.7,20.4-9.2,30-15.5c14.5-9.5,27.7-20.5,37.5-29.3c9.7-8.8,15.9-15.2,16-15.3
          l0.1-0.1l0.1-0.1c48.7-54.3,67.2-103.7,67.5-104.3l-7.6-2.9l7,4.1c5.7-9.9,9.8-21.8,12.9-34.2c4.7-18.7,7.1-38.5,8.4-53.9
          c1.3-15.3,1.5-26,1.5-26.2l0-0.3l0-0.3c-0.7-14.2-1.9-25.1-3.4-33.6c-1.2-6.3-2.5-11.3-3.9-15.3c-2.1-5.9-4.4-9.7-6.9-12.3
          c-1.2-1.3-2.5-2.2-3.8-2.9c-1.2-0.6-2.4-1-3.3-1.1l-1.1,8.1l6.8-4.5c-1.4-2.1-3.2-3.7-5-4.8c-2.8-1.7-5.7-2.6-8.5-3.2
          c-2.8-0.5-5.7-0.7-8.5-0.7c-5.5,0-10.8,0.7-14.9,1.4c-4,0.7-6.8,1.4-6.9,1.4l2,7.9l-1.2-8.1c-10.4,1.5-20,2.2-28.7,2.2
          c-30.1,0-50.3-7.8-63-15.3c-6.3-3.8-10.8-7.5-13.6-10.2c-1.4-1.3-2.4-2.4-3-3.2c-0.3-0.4-0.5-0.6-0.6-0.8l-0.1-0.1l0,0l-3,2.2
          l3-2.2l0,0l-3,2.2l3-2.2L180.8,0h-11.9l-2.4,2.7c-5.8,6.4-12.3,11.6-19.2,15.7c-10.3,6.2-21.5,10-32.4,12.3
          c-10.9,2.3-21.4,3-30.2,3c-7,0-12.9-0.4-17-0.9c-2-0.2-3.6-0.4-4.7-0.6c-0.5-0.1-0.9-0.1-1.2-0.2l-0.3,0l-0.1,0l0,0l-0.8,4.5
          l0.8-4.5l0,0l-0.8,4.5l0.8-4.5L60,39.9l2-7.9L60,39.9z"
        />
      </g>
    </g>
    <g>
      <defs>
        <rect id="SVGID_7_" x="-7" y="-14" width="184" height="400"/>
      </defs>
      <clipPath id="SVGID_8_">
        <use xlinkHref="#SVGID_7_"  overflow="visible"/>
      </clipPath>
      <g clipPath="url(#SVGID_8_)">
        <radialGradient id="SVGID_9_" cx="177.6674" cy="188.4051" r="174.0317" gradientUnits="userSpaceOnUse">
          <stop  offset="0" style={{ stopColor: "#8C6C11" }} />
          <stop  offset="0.5379" style={{ stopColor: "#072551" }} />
          <stop  offset="0.7317" style={{ stopColor: "#07224A" }} />
          <stop  offset="0.8694" style={{ stopColor: "#061D3F" }} />
          <stop  offset="0.9803" style={{ stopColor: "#05162E" }} />
          <stop  offset="1" style={{ stopColor: "#05142A" }} />
        </radialGradient>
        <path className="background-colour" fill="url(#SVGID_9_)" d="M292.6,39.9c0,0-71.8,13.5-112.5-31.8H176c0,0-31.2,43-116.8,30.6c0,0-28.6-7.2-35,2.5
        c0,0-11.6,1.5-14.2,57.3c0,0,1.2,75,21.7,110.3c0,0,18.2,48.5,65.9,101.7c0,0,43.1,44.8,80.4,58.1c0,0,42.8-18.8,77.8-55
        c0,0,56.7-63.3,72.3-114.5c0,0,16.2-26.6,17.1-107.3c-1.1-11.1-2.5-22.3-4.6-33.3c-1.1-5.7-1.8-10-2.9-12.1
        c-6.1-8.7-16.9-12.8-27.5-11.8C310.2,34.7,304.2,37,292.6,39.9z"
        />
        <g>
          <linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="21.4461" y1="118.552" x2="282.3048" y2="118.552">
            <stop  offset="0" style={{ stopColor: isMetal ? 'black' : finish.dark }} />
            <stop  offset="0.2462" style={{ stopColor: isMetal ? 'black' : finish.light }} />
            <stop  offset="0.4444" style={{ stopColor: isMetal ? 'black' : "#FFFFFF" }} />
            <stop  offset="0.695" style={{ stopColor: isMetal ? 'black' : finish.dark }} />
            <stop  offset="1" style={{ stopColor: isMetal ? 'black' : finish.dark }} />
          </linearGradient>
          <polyline fill="url(#SVGID_10_)" points="25.3,202.2 282.3,41.1 278.5,34.9 21.4,196" />
          <linearGradient id="SVGID_11_" gradientUnits="userSpaceOnUse" x1="70.9154" y1="201.1313" x2="349.7231" y2="201.1313">
            <stop  offset="0" style={{ stopColor: isMetal ? 'black' : finish.dark }} />
            <stop  offset="0.2462" style={{ stopColor: isMetal ? 'black' : finish.light }} />
            <stop  offset="0.5422" style={{ stopColor: isMetal ? 'black' : finish.dark }} />
            <stop  offset="0.7693" style={{ stopColor: isMetal ? 'black' : finish.light }} />
            <stop  offset="0.9492" style={{ stopColor: isMetal ? 'black' : "#FFFFFF" }} />
          </linearGradient>
          <polyline fill="url(#SVGID_11_)" points="74.2,290.4 349.7,118 345.9,111.9 70.9,283.9" />
        </g>
        <linearGradient id="SVGID_12_" gradientUnits="userSpaceOnUse" x1="1.9476" y1="188.7122" x2="353.3879" y2="188.7122">
          <stop  offset="0" style={{ stopColor: finish.dark }}  />
          <stop  offset="0.2462" style={{ stopColor: finish.light }} />
          <stop  offset="0.4444" style={{ stopColor: finish.dark }} />
          <stop  offset="0.695" style={{ stopColor: finish.dark }} />
          <stop  offset="1" style={{ stopColor: finish.light }} />
        </linearGradient>
        <path fill="url(#SVGID_12_)" d="M292.6,39.9l-1.5-8l0.8,4.4l-0.8-4.4l0,0l0.8,4.4l-0.8-4.4c0,0-0.1,0-0.4,0.1
          c-2,0.3-10.7,1.7-22.8,1.7c-11.7,0-26.5-1.3-41.2-5.8c-7.3-2.3-14.6-5.3-21.5-9.4c-6.9-4.1-13.4-9.2-19.2-15.7L183.7,0h-11.9
          l-2.4,3.4l4.2,3l-4.2-3.1l0,0l4.2,3l-4.2-3.1l0.7,0.5l-0.7-0.5l0,0l0.7,0.5l-0.7-0.5c0,0.1-5.6,7.4-18.3,14.8
          c-12.7,7.3-32.6,14.7-62.1,14.8c-8.7,0-18.3-0.7-28.7-2.2l-1.2,8.1l2-7.9c-0.1,0-2.9-0.7-6.9-1.4c-4-0.7-9.4-1.4-14.9-1.4
          c-3.7,0-7.5,0.3-11.3,1.4c-1.9,0.6-3.8,1.3-5.7,2.5c-1.8,1.2-6.1,4.6-8,7.1c-2.8,3.7-5.4,9.2-7.6,18.4c-2.2,9.2-4.1,22.1-5,40.8
          l0,0.3l0,0.2c0,0.2,0.3,19.2,3.2,42.8c1.5,11.8,3.6,24.8,6.7,37.2C15,191.2,19,203.1,24.7,213l7-4.1l-7.6,2.9
          c0.2,0.6,18.8,50,67.5,104.3l0.1,0.1l0.1,0.1c0.1,0.1,11.1,11.5,26.9,24.7c7.9,6.6,17,13.6,26.6,19.9c9.6,6.3,19.8,11.9,30,15.5
          l3,1.1l3-1.3c0.3-0.1,11.3-5,26.7-14.4c15.5-9.5,35.5-23.6,53.6-42.3l0.1-0.1l0.1-0.1c0.1-0.1,14.4-16.1,30.8-38.7
          c8.2-11.3,16.9-24.2,24.6-37.7c7.7-13.5,14.4-27.5,18.6-41.2l-7.8-2.4l7,4.2c0.5-0.8,4.8-8.2,9.2-25.7c4.3-17.4,8.7-44.9,9.1-85.8
          l0-0.4l0-0.4c-1.1-11.3-2.5-22.7-4.7-34c-0.5-2.8-1-5.3-1.5-7.6c-0.3-1.2-0.5-2.3-0.9-3.4c-0.3-1.1-0.7-2.2-1.4-3.5l-0.2-0.4
          l-0.3-0.4c-3.6-5.2-8.5-9-13.8-11.6c-5.4-2.6-11.3-3.8-17.2-3.8c-1.3,0-2.6,0.1-3.9,0.2l-1.1,0.1l-1,0.4l1,2.5l-1-2.5l0,0l1,2.5
          l-1-2.5c-0.1,0-5.8,2.2-16.7,4.9L292.6,39.9l-1.5-8L292.6,39.9l2,7.9c11.9-3,18.3-5.4,18.6-5.5l-2.9-7.6l0.8,8.1
          c0.8-0.1,1.6-0.1,2.3-0.1c3.6,0,7.1,0.8,10.2,2.2c3,1.5,5.6,3.6,7.5,6.3l6.7-4.7l-7.2,3.9l1.2-0.6l-1.2,0.6l0,0.1l1.2-0.6
          l-1.2,0.6c0,0,0.1,0.3,0.3,0.8c0.2,0.8,0.5,2,0.8,3.6c0.3,1.5,0.6,3.4,1,5.4c2,10.7,3.4,21.6,4.5,32.6l8.1-0.8l-8.1-0.1
          c-0.4,39.8-4.6,66-8.6,82c-2,8-3.9,13.5-5.3,16.9c-0.7,1.7-1.2,2.8-1.6,3.5c-0.2,0.3-0.3,0.6-0.4,0.7l-0.1,0.1l3.2,1.9l-3.2-1.9
          l0,0.1l3.2,1.9l-3.2-1.9l-0.5,0.9l-0.3,1c-3.6,11.9-9.8,25-17.2,37.8c-11,19.2-24.4,37.7-35,51.3c-5.3,6.8-9.9,12.4-13.2,16.3
          c-1.6,1.9-2.9,3.5-3.8,4.5c-0.4,0.5-0.8,0.9-1,1.2l-0.3,0.3l-0.1,0.1l6.1,5.4L250,308c-16.8,17.4-35.7,30.8-50.4,39.8
          c-7.3,4.5-13.6,7.9-18,10.1c-2.2,1.1-3.9,2-5.1,2.5c-0.6,0.3-1,0.5-1.3,0.6l-0.3,0.1l-0.1,0l0,0l1.1,2.6l-1.1-2.6l0,0l1.1,2.6
          l-1.1-2.6l3.3,7.5l2.7-7.7c-8.4-3-17.7-8-26.6-13.8c-13.4-8.8-26.2-19.4-35.5-27.8c-4.7-4.2-8.5-7.8-11.1-10.4
          c-1.3-1.3-2.3-2.3-3-3c-0.3-0.3-0.6-0.6-0.8-0.8l-0.2-0.2l0,0l0,0l-5.9,5.6l6.1-5.4c-23.4-26.1-39.5-51-49.8-69.4
          c-5.1-9.2-8.8-16.7-11.2-21.9c-1.2-2.6-2-4.6-2.6-6c-0.3-0.7-0.5-1.2-0.6-1.5c-0.1-0.2-0.1-0.3-0.1-0.4l0-0.1l0,0l-3.1,1.2
          l3.1-1.2l0,0l-3.1,1.2l3.1-1.2l-0.2-0.6l-0.3-0.6c-4.5-7.8-8.3-18.5-11.2-30c-4.3-17.3-6.7-36.5-8-51.3c-0.6-7.4-1-13.7-1.2-18.1
          c-0.1-2.2-0.2-4-0.2-5.1c0-0.6,0-1,0-1.3l0-0.3l0-0.1l-8.1,0.1l8.1,0.4c0.6-13.7,1.8-23.9,3.2-31.4c1-5.7,2.2-9.8,3.2-12.7
          c1.6-4.4,2.9-6.1,3.2-6.4c0,0,0.1,0,0.1-0.1l3.2-2.7L31,45.8l0.1-0.1L31,45.8c0,0,0.2-0.1,0.5-0.3c0.6-0.3,1.6-0.6,3-0.8
          c1.4-0.2,3.1-0.3,4.9-0.3c4.1,0,8.7,0.6,12.1,1.2c1.7,0.3,3.2,0.6,4.2,0.8c0.5,0.1,0.9,0.2,1.2,0.3l0.3,0.1l0.1,0l0,0l0.4,0.1
          l0.4,0.1c11.2,1.6,21.5,2.3,31,2.3c33,0,56.3-8.6,71.3-17.6c8-4.8,15-9.3,18.6-12.9c3.2-3.1,3.4-5.5,3.6-5.8L176,8.1v8.1h4.1V8.1
          l-6.1,5.5c7,7.7,14.8,13.9,22.9,18.8c12.2,7.3,25.2,11.7,37.4,14.2c12.3,2.6,23.9,3.3,33.5,3.3c15.4,0,25.8-2,26.2-2l0.2,0
          l0.2-0.1L292.6,39.9z"
        />
      </g>
    </g>
    <image 
      overflow="visible" 
      width="395" 
      height="319" 
      xlinkHref={shineAsset}
      transform="matrix(1 0 0 1 -14.5 18.1526)"
    />
  </svg>
)};
